export function optionPlayScore(r) {
  const msi = Number(r.msi_score || 0);
  const conf = Number(r.confidence || 0);
  const candle = Number(r.candle_score || 0);
  const room = Math.max(0, Math.min(Number(r.recovery_3d_expansion_room_pct || 0), 15));
  const confluence = Number(r.confluence_score || 0);

  let score =
    msi * 0.35 +
    conf * 0.25 +
    candle * 0.2 +
    room * 1.2 +
    confluence * 0.08;

  if (r.bias === "CALL" && r.candle_bias === "BEARISH") score -= 8;
  if (r.bias === "PUT" && r.candle_bias === "BULLISH") score -= 8;
  if (room < 2) score -= 7;
  if (String(r.vix_regime || "").includes("ELEVATED")) score -= 4;

  return Math.max(0, Math.min(100, Math.round(score)));
}

export function optionPlayLabel(r) {
  const score = optionPlayScore(r);

  if (r.bias === "WAIT") return "WAIT";
  if (score >= 85) return "A+";
  if (score >= 78) return "A";
  if (score >= 70) return "B+";
  if (score >= 62) return "B";
  return "WATCH";
}

export function optionPlayType(r) {
  if (r.bias === "CALL") return "Call";
  if (r.bias === "PUT") return "Put";
  return "No Trade";
}
